module.exports = __webpack_public_path__ + "static/media/0288_Medium.1474ad6b.jpg";